import React, { useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Rooms.css";

const Rooms = () => {
  const navigate = useNavigate();

  const [rooms, setRooms] = useState([])

  useEffect(() => {
    const fetchDetails = async()=> {
      const response = await fetch(`${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/fetchRoomDetails`,{
      method : "POST",
      headers : {
        'Content-type': 'application/json'
      }
    });
     const data = await response.json();
     setRooms(data)
    }

    fetchDetails();
   
  }, [])
  

  return (
    <>
      <div className="rooms" id="rooms">
        <h2>Rooms</h2>
        <p>
          Book your cozy hotel room in Ghangaria and enjoy a peaceful stay
          amidst the serene beauty of the Himalayas!
        </p>
        <div className="room-cards">
          {rooms.map((room) => (
            <div className="room-card" key={room._id}>
              <img
                src={room.type === "Double Bed" ? "./images/Room.jpg" : "./images/Room1.jpg"}
                alt={room.type}
              />
              <h3>{room.type} Room</h3>
              <p>Beds : {room.beds}</p>
              <p>Price : {room.amount} per night</p>
              <button onClick={() =>{navigate('/booking', {state : {room}})}}>Book Now</button>

            </div>
          ))}
        </div>
      </div>
    </>
  )};

export default Rooms;
